import moment from "moment";
import config from "config/config";
import { getToken } from "js/formatting/getToken";

export async function getLoans(policyId) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": config.ODS_API_KEY,
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({
      gXdpApi: {
        transactionType: {
          sourceNameSpace: "LIFESYS",
          eventName: "GETLOANS",
          targetNameSpace: "GIDP",
          operation: "GET",
        },
        gIdpPayLoad: {
          loan: {},
          loanPolicies: [
            {
              policyId: policyId,
              asOfDate: moment().format("MM/DD/YYYY"),
            },
          ],
          addOnProperties: {
            lifesys: {
              policyHolder: {
                company: config.COMPANY,
                clientName: config.CLIENTNAME,
                system: "LSN",
                lifeSysDataset: "F",
              },
            },
          },
          numberOfRecordsToReturn: 0,
        },
        correlationID: moment().format("YYYY-MM-DD HH:MM:SS"),
        addOnProperties: {},
      },
    }),
  };

  const response = await fetch(
    config.ODS_API_BASE_URL + "/ce-runtime/GetLoans",
    options
  );
  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    if (data?.gXdpApi?.success) {
      return data.gXdpApi?.gIdpPayLoad?.loanDetails[0];
    }
    return;
  }
}
